// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-list-sorting-switcher{display:flex;align-items:center;color:#b9bdcc!important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;font-size:14px;font-weight:700}.title-list-sorting-switcher__label{margin-inline-end:4px;font-size:14px;font-weight:700}@media(max-width:320px){.title-list-sorting-switcher__label{display:none}}.title-list-sorting-switch-action-sheet .action-sheet-premium-disabled{opacity:.6}", ""]);
// Exports
module.exports = exports;
